/* eslint-disable max-len */
import React from 'react'
import AnimatedList from '../../../../../../../components/Animation/AnimatedList'
import { useNavigate } from 'react-router-dom'
import { useSelector ,useDispatch} from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { convertEpochToDateFormat } from '../../../../../../../CommonMethods/convertEpochToDateFormat'
import { convertToPatientTimeZoneDateFormat } from '../../../../../../../CommonMethods/ConvertDatetoPatientTimezone'
const TableBody=({tableData,
    List,
    indexNum,
    pageNumber,
    selectedIndex,
    setSelectedIndex,
    selectedRef,
    lastIndex,
    setConfirmationState,
    setTextAreaMsg})=>{
    const navigate=useNavigate()
    const auth=useSelector(state=>state?.auth)
    const {userType}=auth
    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
    const [searchParams,setSearchParams]=useSearchParams({})
    

    function calculateAge(dateOfBirth) {
        const birthDate = new Date(dateOfBirth);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDifference = today.getMonth() - birthDate.getMonth();
      
        if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
      
        return age;
    }

    const dateOfBirth = tableData?.date_of_birth;
    const age = calculateAge(dateOfBirth);
     
    return(
        <>
            <AnimatedList
                id={tableData.user_id}
                rowStatus={tableData.status}
                keyItem={indexNum}
                child={
                    <>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624] rounded-tl-[2px] rounded-bl-[2px]">{convertToPatientTimeZoneDateFormat(tableData?.measurement_date_time,dateformat,tableData?.timezone)}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.patient_id}</td>
                        <td id= "patient_name1" className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{[tableData?.first_name, tableData?.middle_name, tableData?.last_name].filter(Boolean).join(' ')}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{age}</td>
                        <td className="px-[18px] py-2 text-sm text-staart font-normal text-[#031624]">{tableData?.device_id===undefined || tableData?.device_id==="" ? "-" : tableData?.device_id}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.alert_type===""||tableData?.alert_type===undefined?"-":tableData?.alert_type}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                            {/* Splitting the reading_details by "/" */}
                            <span className={`${tableData?.reading_details?.includes('/') ? "flex" : ""}`}>
                                {tableData?.reading_details?.split('/').map((detail, index, array) => (
                                    <span key={index}>
                                        <span
                                            className={`${detail === 'Too Low' ? "bg-[#F9E8E9] text-[#D3454D]" :
                                                detail === 'Too High' ? 'bg-[#EEB9BC] text-[#C81720]' :
                                                    detail === 'Nominal' ? 'bg-[#9BD6AD] text-[#1A883C]' :
                                                        (detail === 'Missed Reading' || detail === 'Data Error') ? 'bg-[#E7EAF4] text-[#000000]' : "" }
                                                        rounded-[28px] px-2 py-1`}
                                        >
                                            {detail}
                                        </span>
                                        {index < array.length - 1 && <span className="mx-1">/</span>}
                                    </span>
                                ))}
                            </span>
                        </td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.reading_type===undefined || tableData?.reading_type==="" ? "-" : tableData?.reading_type === 'spo2' ? 'SPO2' : tableData?.reading_type?.split('_')?.map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.reading_value===undefined || tableData?.reading_value===null ? "-" : tableData?.reading_value}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.unit===undefined || tableData?.unit==="" ? "-" : tableData?.unit}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                            {tableData?.acknowledged_at===""||tableData?.acknowledged_at===undefined?"-": convertEpochToDateFormat(tableData?.acknowledged_at,dateformat)}
                        </td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                            {tableData?.acknowledged_by==="" || tableData?.acknowledged_by===undefined ?"-":tableData?.acknowledged_by}
                        </td>
                        <td id='useName' className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                            {(tableData?.acknowledged_first_name || tableData?.acknowledged_last_name)
                                ? [tableData?.acknowledged_first_name, tableData?.acknowledged_last_name].filter(Boolean).join(' ')
                                : "-"
                            }
                        </td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.organization_id===undefined || tableData?.organization_id ==="" ? "-" : tableData?.organization_id}</td>
                        <td id='orgName' className="px-[18px] py-2 text-sm text-start font-normal text-[#031624] rounded-tr-[2px] rounded-br-[2px]">{tableData?.organization_name===undefined || tableData?.organization_name ==="" ? "-" : tableData?.organization_name}</td>
                        
                    </>
                    
                }/>
           
        </>
    )
}

export default TableBody